import { addHours, differenceInDays, differenceInMonths, differenceInWeeks } from 'date-fns';

export function formattedDatesDifference(startDate: Date, endDate: Date) {
  const daysDifference = Math.abs(differenceInDays(addHours(endDate, 1), startDate));
  const weeksDifference = Math.abs(differenceInWeeks(endDate, startDate));
  const monthsDifference = Math.abs(differenceInMonths(endDate, startDate));

  let formattedDifference;

  if (monthsDifference >= 1) {
    formattedDifference = `${monthsDifference}mo`;
  } else if (weeksDifference >= 1) {
    formattedDifference = `${weeksDifference}w`;
  } else {
    formattedDifference = `${daysDifference}d`;
  }

  return formattedDifference;
}
